import { ILegal } from 'entities/LegalEntity/LegalEntity.models';

export const getLegalEntityOptions = (list: ILegal[]) => {
  return list.map((legal) => ({ label: legal.name, value: legal.id }));
};
